module.exports = __webpack_public_path__ + "media/images/pic/news-main-8a5cfb60800e1a2130328a2059c0578d.jpg";